import { render, staticRenderFns } from "./addlifeservice.vue?vue&type=template&id=4d74a106&scoped=true&"
import script from "./addlifeservice.vue?vue&type=script&lang=js&"
export * from "./addlifeservice.vue?vue&type=script&lang=js&"
import style0 from "./addlifeservice.vue?vue&type=style&index=0&id=4d74a106&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d74a106",
  null
  
)

export default component.exports